import type { FedopsLogger as WixFedopsLogger } from '@wix/yoshi-flow-editor/fedops';
import type { EditorReadyOptions } from '@wix/platform-editor-sdk';
import _ from 'lodash';

export type IFedopsLogger = WixFedopsLogger;

export function createFedopsLogger(options: EditorReadyOptions): IFedopsLogger {
  const fedopsLogger = options.monitoring.createFedopsLogger();
  // TODO remove this check once universal-editor-app is added to the platform map
  return _.isFunction(fedopsLogger)
    ? fedopsLogger('universal-editor-app')
    : fedopsLogger;
}
